import { useNavigate } from 'react-router-dom';
import ParchmentLayout from '../components/ParchmentLayout';
import OrnamentSeparator from '../components/OrnamentSeparator';
import { TEAM_FACTION_NAMES, TEAM_TEXT_COLOR } from '../components/teamTheme';

const TEAM_FACTION_ARTICLE: Record<string, string> = {
  GREEN: "della",
  RED: "della",
  BLUE: "dell'",
  YELLOW: "della",
};

function WelcomeScreen() {
  const navigate = useNavigate();
  const teamColor = (localStorage.getItem('teamColor') || 'BLUE').toUpperCase();
  const factionName = TEAM_FACTION_NAMES[teamColor] || 'Squadra';
  const teamTextClass = TEAM_TEXT_COLOR[teamColor] || 'text-ink';
  const article = TEAM_FACTION_ARTICLE[teamColor] || "della";

  const handleContinue = () => {
    navigate('/audience', { replace: true });
  };

  return (
    <ParchmentLayout teamColor={teamColor} className="flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="parchment-card p-8">
          <div className="text-center mb-6">
            <img src="/images/dw_logo.png" alt="Dungeon World" className="mx-auto w-48 mb-1" />
          </div>

          <OrnamentSeparator />

          <div className="text-center my-6 space-y-4">
            <p className="text-ink font-heading text-xl italic">
              Il portale è aperto, l'Avventura ti attende!
            </p>

            <p className="text-ink-light font-body text-lg">
              Fai parte {article}
              <span className={`font-heading font-bold ${teamTextClass}`}>{factionName}</span>
            </p>

            <p className="text-ink font-heading text-xl italic">
              Sarai tu a decidere il destino dei tuoi eroi. Votali, sostienili, guidali.
              <br />
              Cerca di non farli morire subito.
            </p>
          </div>

          <OrnamentSeparator />

          <div className="text-center my-6">
            <p className="text-ink-light font-body text-base">
              La prima scelta a cui sarai chiamato è quale sarà l'eroe
              a rappresentare la tua fazione.
              <br />
              Guarda le schede personaggio e preparati al voto!
            </p>
          </div>

          <OrnamentSeparator />

          <button
            onClick={handleContinue}
            className="w-full btn-fantasy text-xl py-4"
          >
            Scopri i tuoi Eroi
          </button>
        </div>
      </div>
    </ParchmentLayout>
  );
}

export default WelcomeScreen;
